import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Register service worker for PWA / offline support (production only)
if ('serviceWorker' in navigator && window.location.protocol === 'https:') {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/service-worker.js', { scope: '/' })
            .then((reg) => {
                // Auto-update : force la vérification d'une nouvelle version (déploiements)
                reg.update().catch(() => { });
                setInterval(() => reg.update().catch(() => { }), 60 * 60 * 1000);
                reg.addEventListener('updatefound', () => {
                    const sw = reg.installing;
                    if (!sw) return;
                    sw.addEventListener('statechange', () => {
                        if (sw.state === 'installed' && navigator.serviceWorker.controller) {
                            sw.postMessage('SKIP_WAITING');
                        }
                    });
                });
                // Recharge une seule fois quand un NOUVEAU SW remplace l'ancien.
                // Au tout premier chargement (claim initial), ne PAS recharger :
                // cela avortait les requêtes en cours (formulaires publics, fetch CMS).
                let hadController = !!navigator.serviceWorker.controller;
                let reloaded = false;
                navigator.serviceWorker.addEventListener('controllerchange', () => {
                    if (!hadController) { hadController = true; return; }
                    if (reloaded) return;
                    reloaded = true;
                    window.location.reload();
                });
            })
            .catch((err) => console.warn('[SW] registration failed:', err));
    });
}
